import React from 'react'

function Footer() {
  return (
    <div className='footer'>Creado por Alfredo Pérez y Alejandro Rodríguez 2025, todos los derechos reservados</div>
  )
}

export default Footer